export enum MarketType {
  AllDayMarket = 'All Day Market',
  AfterSchoolMarket = 'After-School Market',
  SeasonalMarket = 'Seasonal Market'
}
